import CloseIcon from "@mui/icons-material/Close";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { AppBar, Dialog, Slide, Toolbar } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { IconButton } from "@myloc/myloc-gui";
import { IScannerProps } from "@yudiel/react-qr-scanner";
import React, { ComponentPropsWithoutRef, useCallback } from "react";
import { useTranslate } from "../../../language/i18n";
import LoadingSpinner from "../Spinner/LoadingSpinner";
import Scanner from "./Scanner";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SCAN_DELAY = 100;

export default function ScannerDialog({
  handleClose,
  open,
  titleId = "SCAN_CODE",
  onScan,
  isLoading = false,
}: {
  handleClose: () => void;
  open: boolean;
  titleId?: string;
  onScan: IScannerProps["onScan"];
  isLoading?: boolean;
}) {
  const translate = useTranslate();

  const handleScan = useCallback<ComponentPropsWithoutRef<typeof Scanner>["onScan"]>(
    (...args) => {
      // Slight delay to debounce rapid scanner to allow cleanup functions and unmounted components to complete
      setTimeout(() => {
        onScan(...args);
      }, SCAN_DELAY);
    },
    [onScan],
  );

  return (
    <Dialog fullScreen={true} open={open} onClose={handleClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: "relative", background: "#cfeaf1", color: "#706f6d" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize="large" />
          </IconButton>
          <h4 style={{ margin: 0 }}>{translate(titleId)}</h4>
          <QrCodeScannerIcon fontSize="large" />
        </Toolbar>
      </AppBar>
      {isLoading ? <LoadingSpinner /> : open && <Scanner onScan={handleScan} />}
    </Dialog>
  );
}
